<template>
  <div class="messenger">
    <div class="chatMenu">
      <div class="chatMenuWrapper">
        <v-app-bar flat color="white" class="mb-3">
          <v-avatar class="mr-3" size="30" elevation="10">
            <img v-if="userProfile.Image != null" :src="userProfile.Image" />
            <img v-else src="../../assets/default.png" />
          </v-avatar>
          <v-toolbar-title class="title">
            Chat
          </v-toolbar-title>
        </v-app-bar>
        <v-text-field
          filled
          rounded
          dense
          label="Search Conversation"
          append-icon="mdi-magnify"
          color="grey"
        ></v-text-field>
        <div
          v-for="conversation in conversations"
          :key="conversation._id"
          @click="getConversation(conversation)"
        >
          <conversation
            :conversation="conversation"
            :user-id="userID"
            :online="socketUser"
          />
        </div>
      </div>
    </div>
    <div class="chatBox">
      <div class="chatBoxWrapper">
        <div class="title-border">
          <v-app-bar flat color="white">
            <v-avatar class="mr-3" size="35" elevation="10">
              <img v-if="user.Image != null" :src="user.Image" />
              <img v-else src="../../assets/default.png" />
            </v-avatar>
            <v-toolbar-title class="title text-body-1">
              {{ user.Name }}
            </v-toolbar-title>
          </v-app-bar>
        </div>
        <div class="chatBoxTop" ref="scrollRef">
          <div v-if="currentConversation == null">
            <h2>Start New Conversation</h2>
          </div>
          <div v-for="message in messages" :key="message._id" v-else>
            <message
              :message="message"
              :own="message.sender === userID"
              :profileImg="user.Image"
            />
          </div>
        </div>
        <div class="chatBoxBottom">
          <v-text-field
            dense
            rounded
            class="chatMessageInput mb-n5"
            v-model="newMessage"
            append-outer-icon="mdi-send"
            filled
            clear-icon="mdi-close-circle"
            clearable
            label="Message"
            type="text"
            @click:append-outer="sendMessage"
            @click:clear="clearMessage"
          ></v-text-field>
        </div>
      </div>
    </div>
    <div class="chatOnline">
      <div class="chatOnlineWrapper">
        <v-card class="text-center mt-10 mb-3" shaped elevation="0">
          <div class="mb-5">
            <v-badge
              bordered
              bottom
              :color="user.Online ? 'green' : 'red'"
              dot
              offset-x="11"
              offset-y="13"
            >
              <v-avatar class="mt-n7" size="60" elevation="10">
                <img v-if="user.Image != null" :src="user.Image" />
                <img v-else src="../../assets/default.png" />
              </v-avatar>
            </v-badge>
            <v-card-title class="layout justify-center">{{
              user.Name
            }}</v-card-title>
            <v-card-subtitle class="layout justify-center mt-n3">{{
              user.Role
            }}</v-card-subtitle>
          </div>
        </v-card>

        <v-divider></v-divider>

        <v-toolbar flat>
          <v-toolbar-title class="text-body-1"
            >Online Staff ({{ totalOnlineUser }})</v-toolbar-title
          >
        </v-toolbar>

        <v-divider></v-divider>
        <div class="onlineList">
          <div
            v-for="user in users"
            :key="user._id"
            @click="selectedUserHandler(user)"
          >
            <online :users="user" :user-id="userID" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import conversation from "../chat/conversation";
import online from "../chat/online";
import message from "../chat/message";
import axios from "axios";
const url = require("../../client_config/config").url;
import socket from "../../socket";

export default {
  components: {
    conversation,
    message,
    online,
  },

  data() {
    return {
      message: "",
      conversations: [],
      messages: [],
      currentConversation: [],
      userID: localStorage.getItem("userID"),
      newMessage: "",
      senderId: "",
      users: [],
      selectedUser: [],
      newConversationId: "",
      socketUser: [],
      userProfile: [],
      defaultImg: "../../assets/default.png",
      socketOnlineUser: [],
    };
  },

  async created() {
    socket.connect();

    await this.getUsers();

    socket.emit("addUser", this.userID);

    socket.on("getUsers", (users) => {
      this.socketOnlineUser = this.users.filter((online) =>
        users.map((u) => u.userId).includes(online._id)
      );
      let onlineUser = [];
      for (let i = 0; i < users.length; i++) {
        onlineUser.push(users[i].userId);
      }

      let newUser = [];

      this.users.map((user) => {
        newUser.push({
          ...Object.assign({}, user),
          Online: onlineUser.includes(user._id) ? true : false,
        });
      });

      this.socketUser = onlineUser;
      this.users = newUser;
    });

    socket.on("getMessage", (data) => {
      const postMessage = {
        sender: data.senderId,
        text: data.text,
        createdAt: Date.now(),
      };

      this.messages = [...this.messages, postMessage];
    });

    this.getUserConversation();
  },

  computed: {
    user() {
      return this.selectedUser;
    },
    totalOnlineUser() {
      return this.users.filter((user) => user.Online === true).length;
    }
  },

  methods: {
    scrollToEnd() {
      this.$refs.scrollRef.scrollTop = this.$refs.scrollRef.scrollHeight;
    },

    clearMessage() {
      this.message = "";
    },
    resetIcon() {
      this.iconIndex = 0;
    },
    changeIcon() {
      this.iconIndex === this.icons.length - 1
        ? (this.iconIndex = 0)
        : this.iconIndex++;
    },
    async getUsers() {
      try {
        const res = await axios.get(`${url}/users`);
        this.users = res.data.users;
        this.userProfile = this.users.find((u) => u._id === this.userID);
        let i = 0;
        let ind = -1;

        for (i = 0; i < this.users.length; i++) {
          if (this.users[i].Email == localStorage.getItem("userEmail")) {
            ind = i;
          }
        }
        if (ind > -1) {
          this.users.splice(ind, 1);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getUserConversation() {
      try {
        const res = await axios.get(`${url}/conversation/${this.userID}`);
        this.conversations = res.data;
      } catch (err) {
        console.log(err);
      }
    },

    async getConversation(currentConversation) {
      this.currentConversation = currentConversation;
      this.scrollToEnd();
      try {
        const res = await axios.get(
          `${url}/message/${
            currentConversation ? currentConversation?._id : currentConversation
          }`
        );
        this.messages = res.data;
      } catch (err) {
        console.log(err);
      }

      const staffId = currentConversation.members.find(
        (m) => m !== this.userID
      );

      this.selectedUser = this.users.find((u) => u._id === staffId);
    },

    async sendMessage() {
      if (this.currentConversation === null) {
        this.addNewConversation();
      } else {
        this.addNewMessage(this.currentConversation._id);
      }
    },

    async addNewMessage(conversationId) {
      const message = {
        sender: this.userID,
        text: this.newMessage,
        conversationId: conversationId,
      };

      const receiverId = this.currentConversation?.members.find(
        (m) => m !== this.userID
      );

      const onlineStaff = this.socketOnlineUser?.find(
        (u) => u._id === receiverId
      );

      const sendMessage = async () => {
        try {
          const res = await axios.post(`${url}/message/`, message);
          this.messages = [...this.messages, res.data];
          this.newMessage = "";
          this.scrollToEnd();
        } catch (err) {
          console.log(err);
        }
      };
      if (onlineStaff) {
        socket.emit("sendMessage", {
          senderId: this.userID,
          receiverId,
          text: this.newMessage,
        });
        sendMessage();
      } else {
        sendMessage();
        this.getUserConversation();
      }

      this.resetIcon();
      this.clearMessage();
    },

    async addNewConversation() {
      const newConversation = {
        senderId: this.userID,
        receiverId: this.selectedUser._id,
      };

      try {
        const res = await axios.post(`${url}/conversation/`, newConversation);
        this.newConversationId = res.data._id;
        this.addNewMessage(res.data._id);
        this.getConversation(res.data._id);
      } catch (err) {
        console.log(err);
      }
    },

    async selectedUserHandler(data) {
      this.selectedUser = data;
      try {
        const res = await axios.get(
          `${url}/conversation/find/${data._id}/${this.userID}`
        );

        this.getConversation(res.data);
      } catch (err) {
        console.log(err);
      }
    },
  },

  updated() {
    this.scrollToEnd();
  },

  mounted() {
    this.scrollToEnd();
  },
};
</script>

<style>
.messenger {
  height: calc(100vh - 70px);
  display: flex;
}

.chatMenu {
  flex: 3.5;
  border-right: 2px solid rgb(245, 241, 241);
}

.chatMenuInput {
  width: 90%;
  padding: 10px 0;
  border: none;
  border-bottom: 1px solid gray;
}

.chatBox {
  flex: 5.5;
  border-right: 2px solid rgb(245, 241, 241);
}

.chatBoxWrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}

.chatBoxTop {
  height: 100%;
  overflow-y: scroll;
  padding-right: 10px;
  scroll-behavior: smooth;
}

.onlineList {
  height: 65%;
  overflow-y: scroll;
  padding-right: 10px;
}

.chatBoxBottom {
  margin: 5px 10px 0px 10px;
}

.chatOnline {
  flex: 3;
}

.chatMenuWrapper,
.chatOnlineWrapper {
  padding: 10px;
  height: 100%;
}
.chatBoxWrapper {
  height: 98%;
}

.title-border {
  border-bottom: 2px solid rgb(245, 241, 241);
}

@media screen and (max-width: 1366px) {
  .onlineList {
    height: 60%;
  }
}

@media screen and (min-width: 1920px) {
  .onlineList {
    height: 80%;
  }
}
</style>
